import ky from 'ky';

export const uploadFile = async (url: string, body: any) => {
  return ky
    .put(url, {
      body,
      timeout: 4 * 60 * 1000,
    })
    .catch(async (e) => {
      // intercept error for logging then re-throw for caller-specific error handling
      console.error('Error uploading file', e);
      if (e.response) {
        console.error('Additional file error details', { error: e, response: await e.response.text() });
      }
      throw e;
    });
};
